


























































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { integralManagementServer } from '@/api/installServer';
import { TableStripe } from '@/mixins/tableStripe';
import dayjs from 'dayjs';
import PagingUnit from '@/components/paging/paging.vue';

@Component({
  components: { PagingUnit },
  mixins: [TableStripe],
})
export default class DetailUnit extends Vue {
  @Prop() row!: any;
  scrollbar = false;
  private dataRow: any = '';

  private staffInfo: any = '';
  private tableData: any = [];
  private formData: any = {
    count: 0,
    date: '',
    operationType: '',
  };
  queryDataForm: object = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 1000; // 数据总共多少条

  created() {
    this.dataRow = this.row;
    this.getStaffInfo();
    const startDate: any = dayjs().format('YYYY-MM-01 HH:mm:ss');
    const endDate: any = dayjs().format('YYYY-MM-DD HH:mm:ss');
    this.formData.date = [startDate, endDate];
    this.getRecord();
  }

  /**
   * @desc 人员信息
   * */
  private getStaffInfo() {
    integralManagementServer
      .getIntegralInfoStaff({
        staffId: this.dataRow.staffId,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.staffInfo = res.data;
        } else {
          this.$message.warning('网络异常，请稍后重试！');
        }
        console.log(res);
      })
      .catch(() => {});
  }

  /**
   * @desc 积分记录列表
   * */

  private getRecord() {
    integralManagementServer
      .getIntegralInfoRecord({
        staffId: this.dataRow.staffId,
        startTime: this.formData.date ? this.formData.date[0] : null,
        endTime: this.formData.date ? this.formData.date[1] : null,
        current: (this.queryDataForm as any).pageNo,
        size: (this.queryDataForm as any).pageSize,
      })
      .then((res: any) => {
        if (res.code === '200') {
          this.tableData = res.data.records;
          this.total = res.data.total;
          this.tableData.forEach((item: any) => {
            this.formData.count += item.num;
          });
        }
      });
  }
  getListData() {
    this.getRecord();
  }

  changeHandle() {
    this.formData.count = 0;
    (this.queryDataForm as any).pageNo = 1;
    this.getRecord();
  }
  mounted() {
    this.hasScrollbar();
  }

  hasScrollbar() {
    const dom: any = document.querySelector('.main');
    this.scrollbar = dom.scrollHeight > dom.clientHeight || dom.offsetHeight > dom.clientHeight;
  }

  close() {
    this.$emit('on-response');
  }
}
